import { h } from 'preact';
import React, { useContext } from 'react';
import { DefaultLanguageContext } from './contexts';

export const getParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const getFirstOfType = (type, components = []) => {
  let target = null;
  for (let i = 0; i < components.length; i++) {
    if (components[i].type === type) return components[i];
    else if (!target) target = getFirstOfType(type, components[i].children);
  };
  return target;
};

export const getById = (id, components = [], iteration = 0) => {
  let target = null;
  for (let i = 0; i < components.length; i++) {
    if (components[i].id === id) return components[i];
    else if (!target) target = getById(id, components[i].children, iteration + 1);
  };
  return target;
};

export const deepClone = (item) => {
  if (item instanceof Array) return item.map(i => deepClone(i));
  else if (typeof item === 'object' && item !== null) {
    return Object.entries(item).reduce((newObj, [key, value]) => ({
      ...newObj,
      [key]: deepClone(value)
    }), {})
  }
  else return item;
};

export const formatPhoneNumber = (phoneNumber) => phoneNumber ? phoneNumber.length === 10 ? `${'+1'}${phoneNumber}` : `${'+'}${phoneNumber}` : '';

export const validatePhone = (phoneNumber) => phoneNumber ? /^\d{10}$/.test(phoneNumber.trim()) || /^\d{11}$/.test(phoneNumber.trim()) : true;
export const validateSsn = (ssn) => ssn ? /^\d{4}$/.test(ssn.trim()) : true;
export const validateEmail = (email) => /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(email);
export const addStylesToHead = (styles) => {
  const previous = document.getElementById('custom-styles');
  if (previous) previous.remove();
  const node = document.createElement('style');
  node.setAttribute('id', 'custom-styles');
  node.innerHTML = styles;
  document.body.appendChild(node);
}
export const convertClassName = (name) => {
  if (!name) return '';
  return ' ' + name.replace('.', '').replace('#', '');
}

export const getBrowserLanguage = () => {
  let language = (navigator.languages && navigator.languages[0]) ||
    navigator.language ||
    navigator.userLanguage;

  language = language && language.length >= 2 ? language.substring(0, 2).toUpperCase() : 'EN';
  const isNorwegian = ['NO', 'NB', 'NN'].includes(language);

  //following line is for iOS. we set norwegian to 'NO' in portal and browsers use 'NO'. iOS uses 'NB' so we must change it to 'NO'
  return isNorwegian ? 'NO' : language;
}

export const fieldsAreFilled = (formFields) => Object.values(formFields)
  .reduce((isFilled, field) => {
    field.error = field.required && field.value === '';
    return !field.error && isFilled
  }, true);

export const fieldsAreFilledValidly = (formFields) => Object.values(formFields)
  .reduce((isFilledValidly, field) => {
    field.error = field.mustBeVal !== null ? field.value !== field.mustBeVal : false;
    return !field.error && isFilledValidly
  }, true);

export const makeQueryParams = (keyPairs) => Object.entries(keyPairs)
  .reduce((queryParams, [key, value]) => `${queryParams}&${key}=${value}`, '?');

export const makeText = (isDev, settings, key, language) => {
  if (isDev) {
    return (settings.languages[settings.selectedLanguage] && settings.languages[settings.selectedLanguage][key])
      ? settings.languages[settings.selectedLanguage][key]
      : (settings.languages[language] && settings.languages[language][key])
        ? settings.languages[language][key]
        : settings[key];
  } else {
    return settings.languages[language] && settings.languages[language][key] || settings[key];
  };
};

export const languageUsed = (languageToUse, settings, key) => {
  return (settings.languages[languageToUse] && (settings.languages[languageToUse][key] !== undefined))
    ? languageToUse
    : useContext(DefaultLanguageContext);
}

export const formatDescription = (description = '') => {
  return description
    .split(/\r\n|\r|\n/)
    .map((line, i, lines) => {
      if (!line) {
        return
      };

      if (line.includes('<')) {
        line = line.replace(/(<([^>]+)>)/ig, '');
      }

      return (line[0] === '*' && i !== 0)
        ? <li>{line.slice(1)}</li>
        : (
          <div>
            {i !== 0 && <br />}
            <div>{line[0] === '*' ? line.slice(1) : line}</div>
            {(i !== lines.length - 1) && <br />}
          </div>
        );
    });
}

const isLangInJSON = (targetLang, components = []) => {
  let found = false;
  for (let i = 0; i < components.length; i++) {
    const { settings, children } = components[i];
    if (settings && settings.languages && settings.languages[targetLang] && settings.languages[targetLang].text) {
      if (settings.languages[targetLang].text !== "<p><br></p>" ) {
        return true;
      };
    } else if (!found) {
      found = isLangInJSON(targetLang, children);
    }
  };
  return found;
}

export const isLangSupported = (languageSelected, settings, components) => {
  if (settings.supportedLanguages && settings.supportedLanguages.length) {
    return settings.supportedLanguages.includes(languageSelected);
  };

  if (settings.language || settings.defaultLanguage) {
    if (languageSelected === settings.language || languageSelected === settings.defaultLanguage) {
      return true;
    };
  };

  return isLangInJSON(languageSelected, components);
}